// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3IhZK","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__35qwr"};